/**
 * Ürün kategori sınıflandırma yardımcıları.
 * "Kamera" olarak sayılması gereken ürünler SADECE aşağıdaki 3 dashcam'dir.
 * Diğer "Kamera Ürünleri" kategorisindeki ürünler Sensör olarak sayılır.
 */

export const CAMERA_PRODUCT_NAMES = [
  "DC-M20X 2CH AI DASHCAM (SIM 5GB/24AY)",
  "DC-M42 4CH AI DASHCAM (SIM 5GB/24AY)",
  "DC-M43 4CH AI DASHCAM MON (SIM 5GB/24AY)",
];

const normalize = (name) => {
  if (!name) return '';
  let n = name.trim().toLowerCase();
  n = n.replace(/\(\s+/g, '(').replace(/\s+\)/g, ')');
  n = n.replace(/\s+/g, ' ');
  return n;
};

const CAMERA_NAMES_NORMALIZED = CAMERA_PRODUCT_NAMES.map(normalize);

/**
 * Ürün adı 3 dashcam listesinde mi?
 */
export const isCameraProduct = (productName) => {
  if (!productName) return false;
  return CAMERA_NAMES_NORMALIZED.includes(normalize(productName));
};
